const Logout = () => {
    window.location.href = '/logout'
    return null
}

export default Logout
